import BranchLogoPanel from './branchLogoPanel.container'

export default BranchLogoPanel;
